module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.89889688147bd7575d63.svg";


//////////////////
// WEBPACK FOOTER
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/assets/fonts/bootstrap/glyphicons-halflings-regular.svg?v=4.4.0
// module id = 025F
// module chunks = 1